/* YAP local installers kit (yl-), 2026-10-09. Reveal once, and play the coverage map once when it comes into view.
   Phones, tablets and reduced motion get everything visible at once (no observers, no map play). */
(function () {
  if (window.__ylKit) return;
  window.__ylKit = true;
  var still = window.matchMedia('(max-width: 989px), (prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window);

  function init(root) {
    if (root.__yl) return;
    root.__yl = true;
    var maps = root.querySelectorAll('[data-yl-map]');
    if (still) { maps.forEach(function (m) { m.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.25 });
    root.querySelectorAll('[data-yl-in]').forEach(function (el) { io.observe(el); });
    maps.forEach(function (m) { m.classList.add('is-ready'); io.observe(m); });
  }

  function boot() { document.querySelectorAll('[data-yl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
